<template>
<div>
  <header class="l-header report-print-header">
    <div class="inner">
      <Loading :isProcessing="isProcessing"></Loading>
      <!-- ヨクスル or 労務サプリのロゴ入れ替え -->
      <div class="logo" v-if="!isProcessing">
        <router-link tag="a" id="top" :to="{name: 'top'}" tabindex="1">
          <template v-if="!isSupple">
            <img src="@/assets/img/common/logo-set.svg" alt="労務監査クラウド ヨクスル">
          </template>
          <template v-else>
            <img src="@/assets/img/common/logo-roumu-set.svg" alt="労務監査クラウド 労務サプリ">
          </template>
        </router-link>
      </div>
      <div class="service-name" v-if="!isProcessing && appServiceName!='ヨクスル／労務サプリ'">
        <span>{{ appServiceName }}</span>
      </div>

      <!-- ヨクスル -->
      <div v-if="!isSupple && !isProxy && !isProcessing">
        <ul class="menu" v-if="isAllPermission">
          <li :class="{ 'is-current' : $route.meta.globalMenuName === 'diag-master'}" @click="goDiagMaster()"><a class="menu-nav">監査・小診断</a></li>
          <li id="human-capital-list" :class="{ 'is-current' : $route.meta.globalMenuName === 'human-capital'}" @click="goHumanCapital()"><a class="menu-nav">人的資本管理</a></li>
          <li :class="{ 'is-current' : $route.meta.globalMenuName === 'corporate'}" @click="goCorporateList()"><a class="menu-nav">法人一覧</a></li>
          <li :class="{ 'is-current' : $route.meta.globalMenuName === 'guide'}" @click="goGuideList()"><a class="menu-nav">ガイド</a></li>
          <li :class="{ 'is-current' : $route.meta.globalMenuName === 'trial-entry'}" @click="goTrialEntryList()"><a class="menu-nav">トライアル申込</a></li>
          <li id="notice-list" :class="{ 'is-current' : $route.meta.globalMenuName === 'notice'}" @click="goNoticeList()"><a class="menu-nav">お知らせ</a></li>
          <li id="doc" :class="{ 'is-current' : $route.meta.globalMenuName === 'document'}" @click="goDocumentList()"><a class="menu-nav">書式</a></li>
          <li id="solution-master-list" :class="{ 'is-current' : $route.meta.globalMenuName === 'solution-master'}" @click="goSolutionMasterList()"><a class="menu-nav">ソリューションマスタ</a>
          <li><a @click="changePassword(true)">パスワード変更</a></li>
        </ul>
        <!-- システム管理ユーザー -->
        <ul class="menu" v-if="isSystemAdmin">
          <li :class="{ 'is-current' : $route.meta.globalMenuName === 'diag-master'}" @click="goDiagMaster()"><a class="menu-nav">監査・小診断</a></li>
          <li id="human-capital-list" :class="{ 'is-current' : $route.meta.globalMenuName === 'human-capital'}" @click="goHumanCapital()"><a class="menu-nav">人的資本管理</a></li>
          <li id="notice-list" :class="{ 'is-current' : $route.meta.globalMenuName === 'notice'}" @click="goNoticeList()"><a class="menu-nav">お知らせ</a></li>
          <li id="solution-master-list" :class="{ 'is-current' : $route.meta.globalMenuName === 'solution-master'}" @click="goSolutionMasterList()"><a class="menu-nav">ソリューションマスタ</a>
          <li :class="{ 'is-current' : $route.meta.globalMenuName === 'guide'}" @click="goGuideList()"><a class="menu-nav">ガイド</a></li>
          <li :class="{ 'is-current' : $route.meta.globalMenuName === 'corporate'}" @click="goCorporateList()"><a class="menu-nav">法人一覧</a></li>
          <li :class="{ 'is-current' : $route.meta.globalMenuName === 'trial-entry'}" @click="goTrialEntryList()"><a class="menu-nav">トライアル申込</a></li>
        </ul>
        <!-- 専門家ユーザー（管理と一般） 管理:isAdminUser=true 一般isAdminUser=false -->
        <ul class="menu" v-if="isAdmin">
          <li id="notice-list" :class="{ 'is-current' : $route.meta.globalMenuName === 'notice'}" @click="goNoticeList()"><a class="menu-nav">お知らせ</a></li>
          <li id="doc" :class="{ 'is-current' : $route.meta.globalMenuName === 'document'}" @click="goDocumentList()"><a class="menu-nav">書式</a></li>
          <li id="solution-list" :class="{ 'is-current' : $route.meta.globalMenuName === 'solution'}" @click="goSolutionList()"><a class="menu-nav">ソリューション</a></li>
          <li v-if="isAdminUser" @click="goCorporateList()" :class="{ 'is-current' : $route.meta.globalMenuName === 'corporate'}"><a class="menu-nav">法人一覧</a></li>
          <li><a class="menu-nav-help" href="https://support.roumu-kansa.jp" target="_blank"><img src="@/assets/img/common/icon-nav6.svg" alt=""></a></li>
        </ul>
        <!-- 一般ユーザー -->
        <ul class="menu" v-if="!isAllPermission && !isSystemAdmin && !isAdmin">
          <li id="notice-list" :class="{ 'is-current' : $route.meta.globalMenuName === 'notice'}" @click="goNoticeList()"><a class="menu-nav">お知らせ</a></li>
          <li id="doc" :class="{ 'is-current' : $route.meta.globalMenuName === 'document'}" @click="goDocumentList()"><a class="menu-nav">書式</a></li>
          <li><a class="menu-nav-help" href="https://support.roumu-kansa.jp" target="_blank"><img src="@/assets/img/common/icon-nav6.svg" alt=""></a></li>
        </ul>
      </div>

      <!-- 労務サプリ -->
      <div v-if="isSupple && !isProcessing">
        <!-- 専門家ユーザー（管理と一般） 管理:isAdminUser=true 一般isAdminUser=false -->
        <ul class="menu" v-if="isAdmin">
          <li id="rough-diag-list" :class="{ 'is-current' : $route.meta.globalMenuName === 'rough-diag'}" @click="goRoughDiagTop()"><a class="menu-nav2 old-menu"><img src="@/assets/img/common/icon-nav2.svg" alt="">小テスト</a></li>
          <li id="notice-list" :class="{ 'is-current' : $route.meta.globalMenuName === 'notice'}" @click="goNoticeList()"><a class="menu-nav3 old-menu"><img src="@/assets/img/common/icon-nav3.svg" alt="">お知らせ</a></li>
          <li v-if="isAdminUser" @click="goCorporateList()" :class="{ 'is-current' : $route.meta.globalMenuName === 'corporate'}"><a class="menu-nav7 old-menu"><img src="@/assets/img/common/icon-nav7.svg" alt="">法人一覧</a></li>
        </ul>
        <!-- 一般ユーザー -->
        <ul class="menu" v-if="!isAllPermission && !isSystemAdmin && !isAdmin">
          <li id="rough-diag-list" :class="{ 'is-current' : $route.meta.globalMenuName === 'rough-diag'}" @click="goRoughDiagTop()"><a class="menu-nav2 old-menu"><img src="@/assets/img/common/icon-nav2.svg" alt="">小テスト</a></li>
          <li id="notice-list" :class="{ 'is-current' : $route.meta.globalMenuName === 'notice'}" @click="goNoticeList()"><a class="menu-nav3 old-menu" old-menu><img src="@/assets/img/common/icon-nav3.svg" alt="">お知らせ</a></li>
        </ul>
      </div>

      <!-- 代理店 -->
      <div v-if="isProxy && !isProcessing">
        <!-- 専門家ユーザー（管理と一般） 管理:isAdminUser=true 一般isAdminUser=false -->
        <ul class="menu" v-if="isAdmin">
          <li id="diag" :class="{ 'is-current' : $route.meta.globalMenuName === 'diag'}" @click="goDiagTop()"><a class="menu-nav1 old-menu"><img src="@/assets/img/common/icon-nav1.svg" alt="">監査</a></li>
          <li id="rough-diag-list" :class="{ 'is-current' : $route.meta.globalMenuName === 'rough-diag'}" @click="goRoughDiagTop()"><a class="menu-nav2 old-menu"><img src="@/assets/img/common/icon-nav2.svg" alt="">小テスト</a></li>
          <li id="notice-list" :class="{ 'is-current' : $route.meta.globalMenuName === 'notice'}" @click="goNoticeList()"><a class="menu-nav3 old-menu"><img src="@/assets/img/common/icon-nav3.svg" alt="">お知らせ</a></li>
          <li v-if="isAdminUser" @click="goCorporateList()" :class="{ 'is-current' : $route.meta.globalMenuName === 'corporate'}"><a class="menu-nav7 old-menu"><img src="@/assets/img/common/icon-nav7.svg" alt="">法人一覧</a></li>
          <li id="doc" :class="{ 'is-current' : $route.meta.globalMenuName === 'document'}" @click="goDocumentList()"><a class="menu-nav4 old-menu"><img src="@/assets/img/common/icon-nav4.svg" alt="">書式</a></li>
          <li id="solution-list" :class="{ 'is-current' : $route.meta.globalMenuName === 'solution'}" @click="goSolutionList()"><a class="menu-nav5 old-menu"><img src="@/assets/img/common/icon-nav5.svg" alt="">ソリューション</a></li>
          <li ><a class="menu-nav-help" href="https://support.roumu-kansa.jp" target="_blank"><img src="@/assets/img/common/icon-nav6.svg" alt=""></a></li>
        </ul>
        <!-- 一般ユーザー -->
        <ul class="menu" v-if="!isAllPermission && !isSystemAdmin && !isAdmin">
          <li id="diag" :class="{ 'is-current' : $route.meta.globalMenuName === 'diag'}" @click="goDiagTop()"><a class="menu-nav1 old-menu"><img src="@/assets/img/common/icon-nav1.svg" alt="">監査</a></li>
          <li id="rough-diag-list" :class="{ 'is-current' : $route.meta.globalMenuName === 'rough-diag'}" @click="goRoughDiagTop()"><a class="menu-nav2"><img src="@/assets/img/common/icon-nav2.svg" alt="">小テスト</a></li>
          <li id="notice-list" :class="{ 'is-current' : $route.meta.globalMenuName === 'notice'}" @click="goNoticeList()"><a class="menu-nav3"><img src="@/assets/img/common/icon-nav3.svg" alt="">お知らせ</a></li>
          <li id="doc" :class="{ 'is-current' : $route.meta.globalMenuName === 'document'}" @click="goDocumentList()"><a class="menu-nav4 old-menu"><img src="@/assets/img/common/icon-nav4.svg" alt="">書式</a></li>
          <li ><a class="menu-nav-help" href="https://support.roumu-kansa.jp" target="_blank"><img src="@/assets/img/common/icon-nav6.svg" alt=""></a></li>
        </ul>
      </div>

    </div>
    <div class="user-menu">
      <input type="checkbox" id="usernav" v-model="isShow">
      <label for="usernav">
        <div class="user-pos" v-if="isAdmin">{{ this.planName }} {{ this.nm }}</div>
        <div class="user-pos" v-if="!isAdmin">{{ this.nm }}</div>
        <div class="user-mail">{{ this.mailAddress }}</div>
        <span v-if="isTrialExpiredUpClose">もうすぐトライアル利用期限が終了します</span>
      </label>
      <ul v-show="isShow" class="user-nav">
        <li>
          <a @click="goCorporateEdit()">アカウント情報変更</a>
        </li>
        <li>
          <a @click="changePassword(true)">パスワード変更</a>
        </li>
        <li>
          <a @click="goInquiryList()">お問い合わせ</a>
        </li>
        <li>
          <a @click="logout()">ログアウト</a>
        </li>
      </ul>
    </div>
    <transition name="passwordchange-fade">
      <PasswordChangeInputModel
        v-show="execChangePassword"
        @cancel-password-modify="changePassword(false)"
      ></PasswordChangeInputModel>
    </transition>
  </header>
  </div>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import PasswordChangeInputModel from '@/components/pages/password/PasswordChangeInputModal.vue';

export default {
  name: 'HeaderItem',
  components: {
    Loading,
    PasswordChangeInputModel,
  },
  data() {
    return {
      planName: '',
      nm: '',
      mailAddress: '',
      isProcessing: false,
      isAdmin: false,
      isSystemAdmin: false,
      isAllPermission: false,
      isDiagAvailablePlan: false,
      execChangePassword: false,
      isShow: false,
      userAuthNo: null,
      isSupple: false,
      planId: null,
      appServiceName: '',
    }
  },
  computed: {
    isTrialExpiredUpClose() {
      return this.$store.getters['auth/isTrialExpiredUpClose'];
    },
    isAdminUser() {
      return this.userAuthNo != 9;  // 一般ユーザ以外
    },
    corpId() {
      return this.$store.getters['diag/getCorpId'];
    },
    diagResultId() {
      return this.$store.getters['diag/getDiagResultId'];
    },
    isProxy() {
      return this.planId == 3; // 代理店
    }
  },
  created: async function() {

    this.planName =  this.$store.getters['auth/getUser'].planName;
    this.nm = this.$store.getters['auth/getUser'].nm;
    this.mailAddress = this.$store.getters['auth/getUser'].mailAddress;

    this.isProcessing = true;
    const authority = await this.$store.dispatch('auth/getAuthority')
    this.isAdmin = authority.isAdmin;
    this.isSystemAdmin = authority.isSystemAdmin;
    this.isAllPermission = authority.isAllPermission;
    this.isDiagAvailablePlan = authority.isDiagAvailablePlan;
    this.userAuthNo = authority.userAuthNo;
    this.isProcessing = false;
    this.isSupple = authority.isSupple;
    this.planId = authority.planId;

    // アプリケーションサービス名を取得
    await this.getAppConfig();
  },
  methods: {
    logout() {
      this.isProcessing = true;
      this.$store.dispatch('auth/logout', {isSupple: this.isSupple}).then(() => {
        this.isProcessing = false;
      });
    },
    changePassword(value) {
      this.execChangePassword = value;
    },
    goCorporateList() {
      const params = {};
      this.$router.push({ name: 'corporate-list', params: params });
    },
    goCorporate() {
      this.$store.dispatch('user/setCorpId', this.corpId);
      this.$router.push({ name: 'corporate-edit', query: { corpId: this.corpId } });
    },
    async goCorporateEdit() {
      let res = await this.$axios.post('/ld/api/corporate/getMySelf', {});
      if (res) {
        this.$store.dispatch('user/setCorpId', res.data.corpId);
      }
      this.isShow = false;
      this.$router.push({ name: 'account-edit', query: { corpId: res.data.corpId } });
    },
    async goDiagTop() {
      if ( this.diagResultId != null ) {
        this.$router.replace({path: '/diag/'+this.corpId+'/'+this.diagResultId+'/topparam'});
      }else{
        let diagResultId = await this.getLatestDiagResultId(this.corpId);
        if ( diagResultId > 0 ) {
          this.$router.replace({path: '/diag/'+this.corpId+'/'+diagResultId+'/topparam'});
        }else{
          const params = {};
          this.$router.push({ name: 'diag-top', params: params });
        }
      }
    },
    goRoughDiagTop() {
      const params = {};
      this.$router.push({ name: 'rough-diag-list', params: params });
    },
    goNoticeList() {
      const params = {};
      this.$router.push({ name: 'notice-list', params: params });
    },
    goDocumentList() {
      const params = {};
      this.$router.push({ name: 'doc-list', params: params });
    },
    goSolutionList() {
      const params = {};
      this.$router.push({ name: 'solution-list', params: params });
    },
    goInquiryList() {
      this.isShow = false;
      const params = {};
      this.$router.push({ name: 'inquiry-list', params: params });
    },
    goDiagMaster() {
      const params = {};
      this.$router.push({ name: 'master-top', params: params });
    },
    goGuideList() {
      const params = {};
      this.$router.push({ name: 'guide-list', params: params });
    },
    goTrialEntryList() {
      const params = {};
      this.$router.push({ name: 'trial-entry-list', params: params });
    },
    goSolutionMasterList() {
      const params = {};
      this.$router.push({ name: 'solution-master-list', params: params });
    },
    // 人的資本
    goHumanCapital() {
      const params = {};
      this.$router.push({ name: 'human-capital-list', params: params });
    },
    async getLatestDiagResultId(corpId) {
      this.isRendering = true;
      this.isProcessing = true;

      if (corpId) {
        let res = await this.$axios.post('/ld/api/diag/getLatestDiagResultId', {
          corpId: corpId
        });
        if (res.status) {
          this.isRendering = false;
          this.isProcessing = false;
          return res.data.diagResultId;
        }else{
          this.isRendering = false;
          this.isProcessing = false;
        }
      }
    },
    async getDiagResultList(corpId) {
      if (corpId) {
        let res = await this.$axios.post('/ld/api/diag/getDiagResultList', {
          corpId: corpId,
        });
        if (res) {
          this.diagResultList = res.data.diagResultList;
        }
      }
    },
    async getAppConfig() {
      try {
        let res = await this.$axios.post('/ld/api/auth/getAppConfig', {});
        if (res && res.data) {
          this.appServiceName = res.data.appServiceName;
        }
      } catch (error) {
        console.error('Failed to get app config:', error);
      }
    },

  }
}
</script>

<style scoped>
.service-name {
  margin-left: 20px;
  padding: 5px 10px;
  font-size: 14px;
  font-weight: bold;
  color: #333;
}

.service-name span {
  margin: 0;
}

span {
  margin: 10px;
}

.passwordchange-fade-enter-active {
  transition: all .2s ease;
}
.passwordchange-fade-leave-active {
  transition: all .2s ease;
}
.passwordchange-fade-enter
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-50px);
  opacity: 0;
}
.passwordchange-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-50px);
  opacity: 0;
}
</style>
